import {
  getLocalStorageData,
  removeLocalStorageData,
  storeLocalStorageData,
} from "@picovico/utils";
import axiosService from "./lib/axios";

export const storeToken = (
  token?: string,
  deviceId?: string,
  domain?: string,
  tokenPrefix?: string,
) => {
  if (token) {
    storeLocalStorageData("token", `${tokenPrefix ?? ""} ${token}`);
    axiosService.defaults.headers.common.Authorization = token;
  } else {
    removeLocalStorageData("token");
    delete axiosService.defaults.headers.common.Authorization;
  }
  if (deviceId) {
    storeLocalStorageData("deviceId", deviceId);
    axiosService.defaults.headers.common["deviceId"] = deviceId;
  } else {
    delete axiosService.defaults.headers.common["deviceId"];
    removeLocalStorageData("deviceId");
  }

  if (domain) {
    storeLocalStorageData("domain", domain);
    axiosService.defaults.headers.common["domain"] = domain;
  } else {
    delete axiosService.defaults.headers.common["domain"];
    removeLocalStorageData("domain");
  }
};

export const storeAuthTokens = ({
  token,
  deviceId,
  domain,
}: {
  token: string;
  deviceId: string;
  domain: string;
}) => {
  if (token) {
    storeLocalStorageData("token", token);
  }
  if (deviceId) {
    storeLocalStorageData("deviceId", deviceId);
  }
  if (domain) {
    storeLocalStorageData("domain", domain);
  }
};

/**
 * Forget the signed-in person: the stored token, device and tenant, and the
 * `Authorization` default `setAxiosAuthHeaders` / `storeToken` put on the
 * shared axios instance. Without the last, a request still in flight between
 * a log-out and the next log-in (a query still mounted, a retry) went out
 * with the last person's token: the request interceptor only overrides the
 * default while localStorage holds a token.
 */
export const clearAuthTokens = () => {
  removeLocalStorageData("token");
  removeLocalStorageData("deviceId");
  removeLocalStorageData("domain");
  removeLocalStorageData("tDom");
  removeLocalStorageData("cinema_hall");
  delete axiosService.defaults.headers.common.Authorization;
};

export const getAuthTokens = () => {
  return {
    token: getLocalStorageData("token"),
    deviceId: getLocalStorageData("deviceId"),
    domain: getLocalStorageData("domain"),
  };
};

export * from "./tenant";

export const setAxiosAuthHeaders = ({
  token,
  deviceId,
  domain,
  tokenPrefix = "Token ",
}: {
  token: string;
  deviceId: string;
  domain: string;
  tokenPrefix?: string;
}) => {
  if (token) {
    axiosService.defaults.headers.common["Authorization"] = tokenPrefix + token;
  }

  if (deviceId) {
    axiosService.defaults.headers.common["deviceid"] = deviceId;
  }

  if (domain) {
    axiosService.defaults.headers.common["domain"] = domain;
  }
};
